import { useEffect, useMemo, useState } from 'react';

/* =====================================================
   PROGRES CURSURI PE UNITATI

   Cursurile 3 (Contabilitate primara) si 4 (Contabilitate
   aplicata). Progresul vine din `user_lesson_progress`,
   cu id-urile stabile de unitate si lectie din continut.
===================================================== */

export const CONTA_PRIMARA_COURSE_ID = 3;
export const CONTA_APLICATA_COURSE_ID = 4;

const apiUrl = process.env.REACT_APP_API_URL;

const lessonKey = (unitId, lessonId) => `${unitId}-${lessonId}`;


/*
  completedKeys: Set cu "unitId-lessonId" pentru lectiile terminate.
  currentLesson: prima lectie neterminata, in ordinea cursului
                 ({ unitId, lessonId }), sau null daca totul e gata.
*/
export const useUnitCourseProgress = (courseId, units) => {
  const [completedKeys, setCompletedKeys] = useState(() => new Set());

  useEffect(() => {
    let cancelled = false;

    const loadProgress = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/user/lesson-progress?courseId=${courseId}`,
          { credentials: 'include' }
        );

        if (!response.ok) {
          return;
        }

        const rows = await response.json();

        if (!cancelled && Array.isArray(rows)) {
          setCompletedKeys(
            new Set(rows.map((row) => lessonKey(row.chapter_id, row.lesson_id)))
          );
        }
      } catch (err) {
        console.error('Eroare la incarcarea progresului cursului:', err);
      }
    };

    loadProgress();

    return () => {
      cancelled = true;
    };
  }, [courseId]);

  const currentLesson = useMemo(() => {
    for (const unit of units || []) {
      for (const lesson of unit?.lessons || []) {
        if (!completedKeys.has(lessonKey(unit.id, lesson.id))) {
          return { unitId: unit.id, lessonId: lesson.id };
        }
      }
    }

    return null;
  }, [units, completedKeys]);

  return { completedKeys, currentLesson };
};


/* Marcheaza lectia ca terminata. Erorile nu blocheaza iesirea din lectie. */
export const completeUnitCourseLesson = async (courseId, unitId, lessonId) => {
  try {
    const response = await fetch(`${apiUrl}/lesson/complete`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        chapterId: Number(unitId),
        lessonId: Number(lessonId),
        courseId,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
  } catch (err) {
    console.error('Eroare la salvarea progresului lectiei:', err);
  }
};
